import { createAsyncThunk } from '@reduxjs/toolkit';
import { playerSlice } from './reducer';
import { PlayerService } from '../../services/player.service';
import { RequestStatusesEnum } from '../../enums/request-statuses.enum';

export const getPlayerPersonalSegments = createAsyncThunk(
    'player/fetchSegments',
    async ({
        playerId,
        casinoId
    }) => {
        const { actions: { setPersonalSegmentsWaitingStatus } } = playerSlice;
        setPersonalSegmentsWaitingStatus();

        return await PlayerService.fetchPersonalSegments(playerId, casinoId);
    },
    {
        condition: (props, { getState }) => {
            const { playerId, casinoId } = props;
            const { player: { personalSegments: { status } } } = getState();

            const isPropsSet = Boolean(playerId) && Boolean(casinoId);
            const isNoPreviousCalls = status === RequestStatusesEnum.DEFAULT;

            return isPropsSet && isNoPreviousCalls;
        }
    }
);
